module.exports = __webpack_public_path__ + "img/20200318113318701.d3e8b927.png";